/**
 * Function to remove characters from a string that matches the regex provided.
 * @param {string} inputString - The string to process.
 * @param {RegExp} regex - The regex to use to strip the string.
 * @returns {string} - The sanitized string without the matched text.
 */
export function stripRegex(inputString, regex) {
  return inputString.replace(regex, '');
}
